let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kAlum")).then(() => parcelRequire('1yAeE'));